<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-12">
        <div class="font-bold mb-10">All Leads</div>
        <div class="box-mini">
          <div class="p-15 pb-0">
            <div class="row">
              <div class="col-sm-4">
                <table>
                  <td>
                    <template v-if="canManageLeads()">
                      <a @click="openPage('/leads/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
                    </template>
                  </td>
                  <td>
                    <template v-if="canManageLeads()">
                      <a @click="openPage('/leads/addMultiple')" class="btn-primary mr-5"><i class="fas fa-plus-square mr-5"></i>Add Multiple</a>
                    </template>
                  </td>
                  <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                  <td>
                      <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                  </td>
                </table>
              </div>
              <div class="col-sm-2">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Activity
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="is_activity" @change="changeBranch">
                        <option :value="null">Please select</option>
                        <option :value="'yes'">Yes</option>
                        <option :value="'no'">No</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="row">
                  <div class="col-sm-4 col-form-label text-right">
                    Branch
                  </div>
                  <div class="col-sm-8">
                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                        <option :value="null">Please select</option>
                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 text-right">
                <div class="search-header">
                  <div class="custom-search-container">
                    <div class="input-group custom-search">
                      <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                      <span class="icon-magnifier icon-input-custom"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-sm-4" v-if="getRoleId === '1' || getRoleId === '17' || getRoleId === '4' || getRoleId === '20'">
                <div class="row">
                  <div class="col-sm-2 col-form-label text-right mt-3">
                    Sales
                  </div>
                  <div class="col-sm-8">
                   <b-form-select @change="changeBranch" name="sales" v-model="selectedSalesId" class="form-control mt-3" v-validate="'required'">
                    <option :value="''" selected>Please select</option>
                    <option  v-for="item in dataSales" :value="item.id" :key="item.id">{{item.fullname}}</option>
                   </b-form-select>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <hr class="mb-0">
          <div class="p-15">
            <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped"
            :bordered="bordered" :small="small" :fixed="fixed" :responsive="true" :items="items" :fields="fields">
              <template v-slot:cell(name)="data">
<!--              <template slot="name" slot-scope="data">-->
                {{data.item.first_name}} {{data.item.last_name}}
              </template>
              <template v-slot:cell(leads_source_type)="data">
<!--              <template slot="leads_source_type" slot-scope="data">-->
                <span>{{ (data.item.leads_source_type) ? data.item.leads_source_type.name : '-' }}</span>
              </template>
              <template v-slot:cell(sale)="data">
<!--              <template slot="sale" slot-scope="data">-->
                <span>{{ (data.item.sale) ? data.item.sale.fullname : '-' }}</span>
              </template>
              <template v-slot:cell(activity)="data">
<!--              <template slot="activity" slot-scope="data">-->
                <b-badge v-if="data.item.leads_activity === null" variant="danger">No</b-badge>
                <b-badge v-else variant="success">Yes</b-badge>
              </template>

              <template v-slot:cell(membership_status)="data">
<!--              <template slot="activity" slot-scope="data">-->
                <b-badge v-if="data.item.is_member == false" variant="danger">No</b-badge>
                <b-badge v-else variant="success">Yes</b-badge>
              </template>

              <template v-slot:cell(is_blacklist)="data">
<!--              <template slot="activity" slot-scope="data">-->
                <b-badge v-if="data.item.is_blacklist == 1" variant="danger">Yes</b-badge>
                <b-badge v-else variant="success">No</b-badge>
              </template>

              <template v-slot:cell(status)="data">
<!--              <template slot="status" slot-scope="data">-->
                <template v-if="data.item.is_member == false">
                  <template v-if="data.item.isTrial == 0 || data.item.isTrial == 1">
                    <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                  </template>
                  <template v-else>
                      <b-badge :variant="statusMembership('miss_guest')">Miss Guest</b-badge>
                  </template>
                </template>
                <template v-else>
                  <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                </template>
                <!-- <template v-if="data.item.isEmptyForm == false && data.item.is_member == false">
                  <template v-if="data.item.isTransaction == true">
                    <b-badge :variant="statusMembership('miss_guest')">Miss Guest</b-badge>
                  </template>
                  <template v-else>
                    <template v-if="data.item.isLeadsDataEmpty == false">
                        <b-badge :variant="statusMembership('miss_guest')">Miss Guest</b-badge>
                    </template>
                    <template v-else>
                        <b-badge :variant="statusMembership(data.item.leads_status.name)">{{data.item.leads_status.name}}</b-badge>
                    </template>
                  </template>
                </template> -->
              </template>
              <template v-slot:cell(actions)="data">
<!--              <template slot="actions" slot-scope="data">-->

                <!-- :disabled="getRoleId != '33' ? true : false" -->

                <b-button v-if="canManageLeads()" size="sm" @click="openPage('/leads/detail?id=' + data.item.id)" class="btn-table green mb-5 mr-1">
                  <i class="far fa-eye"></i> Detail
                </b-button>

                <b-button v-if="getRoleId != '33' && getRoleId != '1'" size="sm" v-on:click="deleteData(data.item.id)" class="btn-table danger mb-5" :disabled="getRoleId === '1' ? true : false">
                  <i class="fas fa-times"></i> Delete
                </b-button>

                <b-button v-if="getRoleId == '1'" size="sm" v-on:click="deleteData(data.item.id)" class="btn-table danger mb-5">
                  <i class="fas fa-times"></i> Delete
                </b-button>

              </template>
            </b-table>

            <div class="d-flex justify-content-between">
              <!-- limit -->
              <select style="max-width: 10%;" name="limit" id="limit" class="form-control mt-3" v-model="paginationLimit" @change="limitChanged">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>

               <!-- Pagination -->
               <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'leads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loadingActive: false,
      fields: [
        {
          key: 'name',
          label: 'Leads Name',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: true
        },
        {
          key: 'leads_source_type',
          label: 'Lead Source',
          sortable: true
        },
        {
          key: 'sale',
          label: 'Lead Owner',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Created Lead',
          formatter: (value, key, item) => {
            return moment(item.created_at).format('DD MMM YYYY')
          },
          sortable: true
        },
        {
          key: 'activity',
          label: 'Activity',
          sortable: false
        },
        {
          key: 'qty_appointment_daily',
          label: 'Appointment Qty',
          sortable: false
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'membership_status',
          label: 'Membership Status',
          sortable: true
        },
        {
          key: 'is_blacklist',
          label: 'Blacklist',
          sortable: false
        },
        {
          key: 'referral_pt',
          label: 'Referral PT',
          sortable: false,
          formatter: (value, key, item) => {
            return item.referral_pt ? item.referral_pt.name  : '-'
          }
        },
        {
          key: 'referral_member',
          label: 'Referral Member',
          sortable: false,
          formatter: (value, key, item) => {
            return item.referral_member ? item.referral_member.first_name + ' ' + item.referral_member.last_name  : '-'
          }
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: true
        },
      ],
      selectedSalesId: '',
      branch_id: null,
      is_activity: null,
      dataBranch: [],
      dataSales: [],
      dateWeek: '',
      items: [],
      get_data_transaction_leads: [],
      sortType: '',
      isViewOnly: false,
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      // Semua login customer service (CS, CS Manager, CS Supervisor, CS Ast. Manager)
      customerServiceRoleIds: [6, 8, 34, 35],
      // exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+((moment().year()+1) + moment().endOf('month').format('-MM-DD')),
      start_date: null,
      end_date: null,
      paradigm_id:Auth.Session.get().paradigm_id,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))],
        // defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), ((moment().year()+1) + moment().endOf('month').format('-MM-DD'))]
      }
    }
  },
  methods: {
    isCustomerService() {
      return this.customerServiceRoleIds.includes(Number(Auth.Session.get().paradigm_role))
    },
    // Admin/visitor & semua customer service melihat seluruh leads (bukan hanya milik sendiri)
    viewAllLeads() {
      return ['1', '33'].includes(Auth.Session.get().paradigm_role) || this.isCustomerService()
    },
    canManageLeads() {
      return ['1', '4', '3', '20', '27', '6', '17'].includes(this.getRoleId) || this.isCustomerService() || this.paradigm_id === '15101853'
    },
    limitChanged(ev) {
      this.limit = ev.target.value
      this.reloadData()
    },
    exportReport() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      let end_date = dates[1] == undefined ? '' : dates[1]
      let url = 'crm/v1/export/my_leads/reports/1071806?page=&limit=&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
      +'&end_date='+end_date;

      console.log('Role: ', Auth.Session.get().paradigm_role)
      let exludeRole = [1, 33, ...this.customerServiceRoleIds]

      if(!exludeRole.includes(Number(Auth.Session.get().paradigm_role))) {
        url = 'crm/v1/export/my_leads/reports/'+Auth.Session.get().paradigm_id+'?page=&limit=&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
        +'&end_date='+end_date;
      }

      if (this.branch_id != null) {
            url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.loadingActive = false
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Leads Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    },
    changeBranch(event) {
      // console.log(event)
      this.reloadData()

      axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc&branch_id=' + this.branch_id + '&status=active').then(response => {
        this.dataSales = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
            let dates = this.exportDates.split(' to ')
            let start_date = dates[0]
            let end_date = dates[1] == undefined ? '' : dates[1]
            this.start_date = start_date
            this.end_date = end_date
            localStorage.setItem('leads_date_range', `${start_date} to ${end_date}`)
            // this.fetchData()
            this.reloadData
          }
      }
    },
    reloadData() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      this.getRoleId = Auth.Session.get().paradigm_role
      let end_date = dates[1] == undefined ? '' : dates[1]

      let is_activity = ""
      if (this.is_activity == null) {
        is_activity = ""
      } else {
        is_activity = this.is_activity
      }

      if (this.viewAllLeads()) {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
        +'&end_date='+end_date + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else if (Auth.Session.get().paradigm_id === '1078282' || Auth.Session.get().paradigm_id === '1071841') {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
        +'&end_date='+end_date + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else {
        axios.get('crm/v1/leads/my_leads/' + Auth.Session.get().paradigm_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData +'&start_date='+dates[0]
        +'&end_date='+end_date + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity + '&sales_id='+ this.selectedSalesId).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      }
    },
    pageOneChanged (pageNum) {
      let currentUrl = window.location.href
      let url = new URL(currentUrl)
      url.searchParams.set("page", pageNum)
      let newUrl = url.href
      window.history.pushState("Page","Paradigm Fitness Indonesia","?page="+pageNum)
      this.currentPage = pageNum
      this.reloadData()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.reloadData()
    },
    enterClicked (searchEvent) {
      console.log(searchEvent)
      if (searchEvent) {
        this.currentPage = ''
        this.paginationLimit = ''
      } else {
        this.currentPage = 1
        this.paginationLimit = 10
      }

      // this.fetchData()
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      this.getRoleId = Auth.Session.get().paradigm_role
      let end_date = dates[1] == undefined ? '' : dates[1]

      let is_activity = ""
      if (this.is_activity == null) {
        is_activity = ""
      } else {
        is_activity = this.is_activity
      }

      if (this.viewAllLeads()) {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else if (Auth.Session.get().paradigm_id === '1078282' || Auth.Session.get().paradigm_id === '1071841') {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else {
        axios.get('crm/v1/leads/my_leads/' + Auth.Session.get().paradigm_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData  +'&branch_id=' + this.branch_id + '&is_activity=' + is_activity + '&sales_id='+ this.selectedSalesId).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      }
    },
    deleteData(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.delete('crm/v1/leads/' + event).then(response => {
            // this.$router.go()
            this.reloadData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    getRowCount (items) {
      return items.length
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    statusMembership (status) {
      console.log('STATUS: ', status)
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : (status === 'miss_guest') ? 'warning' : 'danger'
    },
    statusActivity (status) {
      return (status === 'Membership') ? 'success'
          : (status === 'On Progress') ? 'warning' : 'danger'
    },
    openPage (event) {
      this.$router.push(event)
    },
    todayNumber () {
      return moment().isoWeekday()
    },
    cutTime (value) {
      return (value).slice(0, -3)
    },
    getNumberDay (value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDateTime1 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2 (value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3 (value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg (value) {
      return Auth.apiUrl + 'crm/v1/img/banner/' + value
    },
    getLeadsTransaction(id) {
       axios.get("crm/v1/leads/get_transaction?leads_id=" + id)
        .then(response => {
          let res_data = response.data.data.rows
          console.warn('VANGKE: ',  res_data.length +' - ' + id)
          console.warn(res_data.length)
          if (res_data.length > 0) {
            return false
          } else {
            return true
          }
        })
        .catch(error => {
          console.log("error", error);
           return false
        });
    },
    fetchData() {
      this.loadingActive = true
      let dates = this.exportDates.split(' to ')
      this.getRoleId = Auth.Session.get().paradigm_role
      let end_date = dates[1] == undefined ? '' : dates[1]

      let is_activity = ""
      if (this.is_activity == null) {
        is_activity = ""
      } else {
        is_activity = this.is_activity
      }

      if (this.viewAllLeads()) {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else if (Auth.Session.get().paradigm_id === '1078282' || Auth.Session.get().paradigm_id === '1071841') {
        axios.get('crm/v1/leads/my_leads/1071806' + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      } else {
        axios.get('crm/v1/leads/my_leads/' + Auth.Session.get().paradigm_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&branch_id=' + this.branch_id + '&is_activity=' + is_activity + '&sales_id='+ this.selectedSalesId).then(response => {
          this.items = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          this.loadingActive = false
        }).catch(error => {
          console.log('error', error)
          this.loadingActive = false
        })
      }

      // branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc&branch_id=' + this.branch_id + '&status=active').then(response => {
        this.dataSales = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    let urlParams = new URLSearchParams(window.location.search)
    let pageParams = urlParams.get('page')
    this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
    const get_current_date = localStorage.getItem('leads_date_range')
    if (get_current_date) {
      this.exportDates = get_current_date
    }
    this.branch_id = Auth.Session.get().paradigm_branch_id

    this.fetchData()

    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
  },
  destroyed() {
    if (this.$router.currentRoute.path != '/leads/detail') {
      localStorage.removeItem('leads_date_range')
    }
  }
}
</script>
